import { render, staticRenderFns } from "./EconNav.vue?vue&type=template&id=177b85e6&scoped=true&"
import script from "./EconNav.vue?vue&type=script&lang=js&"
export * from "./EconNav.vue?vue&type=script&lang=js&"
import style0 from "./EconNav.vue?vue&type=style&index=0&id=177b85e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b85e6",
  null
  
)

export default component.exports